const loading = {
    skipNext: false,
    loadingId: 'loading',
    loadingTemplate: '<div class="dots-loading">'
        +   '<div class="dots-box">'
        +     '<div class="dots-spinner"></div>'
        +       '<p class="lead fw-bold">Optional text&hellip;</p>'
        +     '</div>'
        + '</div>',
    skipNextInvocation: () => {},
    submit: () => {},
    validate: () => {},
    save: () => {},
    del: () => {},
    recall: () => {},
    reset: () => {},
    stop: () => {},
    load: () => {},
    search: () => {},
    overlay: () => {},
    show: () => {},
    remove: () => {},
};

loading.skipNextInvocation = function skipNextInvocation() {
    loading.skipNext = true;
};

loading.submit = function submit() {
    loading.overlay('Submitting&hellip;');
};

loading.validate = function validate() {
    loading.overlay('Validating&hellip;');
};

loading.save = function save() {
    loading.overlay('Saving&hellip;');
};

loading.del = function del() {
    loading.overlay('Deleting&hellip;');
};

loading.recall = function recall() {
    loading.overlay('Recalling&hellip;');
};

loading.reset = function reset() {
    loading.overlay('Resetting&hellip;');
};

loading.stop = function stop() {
    loading.overlay('Stopping&hellip;');
};

loading.load = function load() {
    loading.overlay('Loading&hellip;');
};

loading.search = function search() {
    loading.overlay('Searching&hellip;');
};

loading.overlay = function overlay(message) {
    const _html = $(loading.loadingTemplate);
    _html.addClass('dots-loading-overlay');
    loading.show(message, _html);
};

loading.show = function show(message, _html) {
    if ($(`#${loading.loadingId}`).length || loading.skipNext) {
        loading.skipNext = false;
        return;
    }
    if (!_html) {
        _html = $(loading.loadingTemplate);
    }
    if (message) {
        _html.find('p').html(message);
    } else {
        _html.find('p').remove();
    }
    _html.attr('id', loading.loadingId);

    if (notification) {
        notification.hide();
    }

    $('body').prepend(_html);
};

loading.remove = function hide() {
    $(`#${loading.loadingId}`).remove();
};

window.loading = loading;

export default loading;

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('appHideLoadingIndicator', () => {
        loading.remove();
    });

    document.addEventListener('appShowLoadingIndicator', () => {
        loading.load();
    });
});
